const TextArea = ({entity, fld}) => {

    const defaultChangeHandler = (event) => {
        const {value} = event.target
        if (!!fld.changeHandler) {
            fld.changeHandler(entity.id, fld.name, value)
        } else {
            console.log("defaultChangeHandler", fld.name, value)
        }
    }

    return (
        <textarea
            cols={(!!fld.cols) ? fld.cols : 40}
            rows={(!!fld.rows) ? fld.rows : 2}
            value={entity[fld.name]}
            onChange={defaultChangeHandler}
        />
    )
}

export default TextArea
